import type { FunctionComponent } from "react";
import { PostRejectModalPartial } from "../../../../partials/admin/menus/post/post-reject-modal.admin.partials";

export const PostRejectModalAdminScreen: FunctionComponent = () => {
	return <PostRejectModalPartial />;
};
